import script from "./AuthProjectHours.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthProjectHours.vue?vue&type=script&setup=true&lang=js"

import "./AuthProjectHours.vue?vue&type=style&index=0&id=492ebe4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-492ebe4c"]])

export default __exports__